<template>
  <div class="goods-view-wrap">
    <div
      v-if="list.length === 0"
      class="image-slot">
      <i
        class="el-icon-picture-outline"
        style="font-size:40px;"></i>
    </div>
    <template v-else>
      <div
        v-for="item in list"
        :key="item.exchangeGoodsId"
        class="goods-item">
        <div class="goods-image-wrap">
          <img
            :src="item.goodsSmallImage"
            class="goods-image">
        </div>
        <div class="title">{{ item.goodsName }}</div>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  name: 'WeGoodsView',
  props: {
    list: { type: Array, default() { return [] } }
  }
}
</script>
<style lang="stylus" scoped>
.goods-view-wrap {
  padding: 0 8px;
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto
  min-height: 100px
}
.goods-item {
  flex: 0 0 130px;
  width: 0;
}
.goods-item+.goods-item {
  margin-left: 8px;
}
.goods-image-wrap {
  padding-top: 100%
  position relative
  .goods-image {
    position absolute
    left: 0;
    top: 0
    width: 100%
    height: 100%
    object-fit: cover;
  }
}
.title{
  width: 100%
  overflow hidden
  text-overflow: ellipsis
  white-space: nowrap
  font-size: 14px;
  padding: 0
  margin-top: 4px
}
</style>
